import React, { useContext, useEffect } from 'react'
import DirectoryContext from './state/context'
import Asset from './Asset'
import styled from 'styled-components'

const AssetList = styled.div`
  align-self: flex-start;
  padding: 4px 12px 34px;
  width: 100%;

  @media screen and (min-width: 500px) {
    padding: 24px calc(5.8% - 8px) 4px;
  }

  @media screen and (min-width: 960px) {
    padding-top: 0;
  }

  > div {
    height: 100vh;
    overflow: auto;
    padding: 8px;

    @media screen and (max-width: 767px) {
      min-height: auto !important;
    }

    @media screen and (min-width: 768px) {
      display: flex;
      flex-wrap: wrap;
    }

    > div {
      margin-bottom: 34px;

      @media screen and (min-width: 768px) {
        width: calc(50% - 17px);
        margin-right: 34px;

        &:nth-child(2n) {
          margin-right: 0;
        }
      }

      @media screen and (min-width: 1200px) {
        width: calc(33.32% - 22px);

        &:nth-child(n) {
          margin-right: 33px;
        }

        &:nth-child(3n) {
          margin-right: 0;
        }
      }

      &:last-child {
        margin-bottom: 0;
      }
    }
  }

  ${({ map }) =>
    map &&
    `
      @media screen and (min-width: 960px) {
        padding-left: 34px;
        width: 522px;

        > div {
          > div {
            width: 100%;

            &:nth-child(n) {
              margin-right: 0;
            }
          }
        }
      }
    `}
`

const DirectoryList = (props) => {
  const context = useContext(DirectoryContext)
  const { type } = props

  useEffect(() => {
    context.getAssets(type)
  }, [context.filters])

  return (
    <AssetList map={context.showMap}>
      <div>
        {context.assets
          .sort((a, b) => a.name.localeCompare(b.name))
          .map((asset) => (
            <Asset key={asset.id} item={asset} type={type} />
          ))}
      </div>
    </AssetList>
  )
}

export default DirectoryList
